/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DetachServerClientAssociationRequestBody = {
  /**
   * The MCP server.
   */
  mcpServerId: string;
  /**
   * The associated remote session client.
   */
  remoteSessionClientId: string;
};

/** @internal */
export type DetachServerClientAssociationRequestBody$Outbound = {
  mcp_server_id: string;
  remote_session_client_id: string;
};

/** @internal */
export const DetachServerClientAssociationRequestBody$outboundSchema:
  z.ZodMiniType<
    DetachServerClientAssociationRequestBody$Outbound,
    DetachServerClientAssociationRequestBody
  > = z.pipe(
    z.object({
      mcpServerId: z.string(),
      remoteSessionClientId: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        mcpServerId: "mcp_server_id",
        remoteSessionClientId: "remote_session_client_id",
      });
    }),
  );

export function detachServerClientAssociationRequestBodyToJSON(
  detachServerClientAssociationRequestBody:
    DetachServerClientAssociationRequestBody,
): string {
  return JSON.stringify(
    DetachServerClientAssociationRequestBody$outboundSchema.parse(
      detachServerClientAssociationRequestBody,
    ),
  );
}
